import { __decorate, __awaiter } from 'tslib';
import { EventEmitter, ɵɵdefineInjectable, Injectable, ChangeDetectorRef, Input, Output, Component, NgModule } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { CommonModule } from '@angular/common';

/**
 * Clase con las funciones globales que
 * deberan ser usados por la libreria
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function CiamActiveDirectoryV2Component_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function CiamActiveDirectoryV2Component_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.RegisterLite(); });
    ɵngcc0.ɵɵtext(1, " Crear cuenta lite ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r0.btnClazz, " ngx-not-authenticate");
} }
function CiamActiveDirectoryV2Component_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function CiamActiveDirectoryV2Component_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.Register(); });
    ɵngcc0.ɵɵtext(1, " Crear cuenta ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r1.btnClazz, " ngx-not-authenticate");
} }
function CiamActiveDirectoryV2Component_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function CiamActiveDirectoryV2Component_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.Login(); });
    ɵngcc0.ɵɵtext(1, " Iniciar Sesi\u00F3n ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r2.btnClazz, " ngx-not-authenticate");
} }
function CiamActiveDirectoryV2Component_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function CiamActiveDirectoryV2Component_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.Logout(); });
    ɵngcc0.ɵɵtext(1, " Cerrar Sesi\u00F3n ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r3.btnClazz, " ngx-authenticate");
} }
function CiamActiveDirectoryV2Component_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function CiamActiveDirectoryV2Component_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.EditProfile(); });
    ɵngcc0.ɵɵtext(1, " Editar Cuenta ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r4.btnClazz, " ngx-authenticate");
} }
function CiamActiveDirectoryV2Component_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
} }
let CiamGlobalsFunctions = class CiamGlobalsFunctions {
    constructor() {
        this._searchParams = new URLSearchParams(window.location.search);
        this._eventListenerSession = undefined;
        this.emitEventLogin = new EventEmitter();
    }
    /**
     * Función para agregar la libreria de ciam
     * @param cdn
     * @param apikey
     */
    addLibraryCiam(cdn, apikey) {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = `${cdn}/js/gigya.js?apiKey=${apikey}`;
        s.async = true;
        s.lang = 'javascript';
        document.head.appendChild(s);
    }
    /**
     * Busca una cookie especifica y retorna su valor almacenado
     * @param key
     * @returns
     */
    searchCookie(key) {
        const cookies = document.cookie.split(';');
        const search = cookies.filter((t) => t.includes(`${key}`));
        return search[0].split('=')[1];
    }
    /**
     * Retorna el DV calculado
     * @param nit
     * @returns
     */
    calcularDV(nit) {
        // Se limpia el Nit
        nit = nit.replace(/\s/g, ''); // Espacios
        nit = nit.replace(/,/g, ''); // Comas
        nit = nit.replace(/\./g, ''); // Puntos
        nit = nit.replace(/-/g, ''); // Guiones
        const vpri = new Array(16);
        let z = nit.length;
        vpri[1] = 3;
        vpri[2] = 7;
        vpri[3] = 13;
        vpri[4] = 17;
        vpri[5] = 19;
        vpri[6] = 23;
        vpri[7] = 29;
        vpri[8] = 37;
        vpri[9] = 41;
        vpri[10] = 43;
        vpri[11] = 47;
        vpri[12] = 53;
        vpri[13] = 59;
        vpri[14] = 67;
        vpri[15] = 71;
        let x = 0;
        let y = 0;
        for (let i = 0; i < z; i++) {
            y = nit.substr(i, 1);
            x += y * vpri[z - i];
        }
        y = x % 11;
        return y > 1 ? 11 - y : y;
    }
    /**
     * Almacena datos a la cookie especificada
     * @param key
     * @param value
     */
    setCookie(key, value) {
        document.cookie = `${key}=${value}`;
    }
    /**
     * Almacena datos al localstorage especificada
     * @param key
     * @param value
     */
    setItemLocalStorage(key, value) {
        localStorage.setItem(key, value);
    }
    /**
     * Retorna el valor de la variable almacenada en el
     * localstorage
     * @param key
     * @returns
     */
    getItemLocalStorage(key) {
        return localStorage.getItem(key);
    }
    /**
     * Almacena datos al sessionstorage especificada
     * @param key
     * @param value
     */
    setItemSessionStorage(key, value) {
        sessionStorage.setItem(key, value);
    }
    /**
     * Retorna el valor de la variable almacenada en el
     * sesionstorage
     * @param key
     * @returns
     */
    getItemSessionStorage(key) {
        return sessionStorage.getItem(key);
    }
    /**
     *
     * @param param Retorna True si el parametro existe en la URL
     * @returns
     */
    searchParams(param) {
        return (this._searchParams.has(param) || window.location.href.indexOf(param) > -1);
    }
    getJWT(apiKey, res, typeMarketing, urlAuthenticationCIAM, userData) {
        this.createJWT(apiKey, res, typeMarketing, urlAuthenticationCIAM, userData);
    }
    createJWT(apiKey, res, typeMarketing, urlAuthenticationCIAM, userData) {
        var _a;
        let resTwo = JSON.parse((_a = sessionStorage.getItem(userData)) !== null && _a !== void 0 ? _a : '');
        let params = {
            APIKey: apiKey,
            identifier: this.getDataOfResponse(res, resTwo, typeMarketing),
            pageURL: 'lib',
            identifierType: 'username',
            context: 'JSON',
        };
        let urlAPI = new URL('https://accounts.us1.gigya.com/accounts.identifier.createToken');
        urlAPI.search = new URLSearchParams(params).toString();
        fetch(urlAPI.toString(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
            return response.json();
        })
            .then((data) => {
            if (data.aToken)
                this.getTokenAuthenticationCIAM(data.aToken, urlAuthenticationCIAM, userData);
        })
            .catch((error) => {
            throw new Error('Error en la solicitud: ' + error);
        });
    }
    getDataOfResponse(res, resTwo, typeMarketing) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        let claims = {
            uid: (_a = resTwo === null || resTwo === void 0 ? void 0 : resTwo.UID) !== null && _a !== void 0 ? _a : '',
            customerFirstName: (_c = (_b = resTwo === null || resTwo === void 0 ? void 0 : resTwo.profile) === null || _b === void 0 ? void 0 : _b.firstName) !== null && _c !== void 0 ? _c : '',
            customerLastName: (_e = (_d = resTwo === null || resTwo === void 0 ? void 0 : resTwo.profile) === null || _d === void 0 ? void 0 : _d.lastName) !== null && _e !== void 0 ? _e : '',
            customerTelephoneNumber: (_f = resTwo === null || resTwo === void 0 ? void 0 : resTwo.phoneNumber) !== null && _f !== void 0 ? _f : '',
            customerDocumentType: (_h = (_g = resTwo === null || resTwo === void 0 ? void 0 : resTwo.data) === null || _g === void 0 ? void 0 : _g.tpIdentificacion) !== null && _h !== void 0 ? _h : '',
            customerDocumentNumber: (_k = (_j = resTwo === null || resTwo === void 0 ? void 0 : resTwo.data) === null || _j === void 0 ? void 0 : _j.numeroDocumento) !== null && _k !== void 0 ? _k : '',
            customerEmail: (_m = (_l = resTwo === null || resTwo === void 0 ? void 0 : resTwo.profile) === null || _l === void 0 ? void 0 : _l.email) !== null && _m !== void 0 ? _m : '',
            companyDocumentNumber: (_p = (_o = res === null || res === void 0 ? void 0 : res.info) === null || _o === void 0 ? void 0 : _o.numeroDocumento[0]) !== null && _p !== void 0 ? _p : '',
            companyDocumentType: (_r = (_q = res === null || res === void 0 ? void 0 : res.info) === null || _q === void 0 ? void 0 : _q.tpIdentificacion[0]) !== null && _r !== void 0 ? _r : '',
            timeSession: (_t = (_s = resTwo === null || resTwo === void 0 ? void 0 : resTwo.requestParams) === null || _s === void 0 ? void 0 : _s.sessionExpiration) !== null && _t !== void 0 ? _t : '',
            marketingType: typeMarketing,
        };
        return JSON.stringify(claims);
    }
    /**
     * Metodo encargado de realizar la petición a AUTHENTICATION CIAM.
     *
     * @param url Ruta a la que se enviará la petición.
     * @param idToken JWT recibido en la autenticación, este valor se extrae del sessionStorage
     * @param userData llave utilizada para almacenar la información del usuario en el sessionStorage.
     */
    getTokenAuthenticationCIAM(idToken, urlAuthenticationCIAM, userData) {
        fetch(urlAuthenticationCIAM, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id_token: idToken,
            }),
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error('Error en la respuesta: ' + response.statusText);
            }
            return response.json();
        })
            .then((data) => {
            if (data.access_token)
                this.decodeToken(data, data.access_token, userData);
        })
            .catch((error) => {
            throw new Error('Error en la solicitud: ' + error);
        });
    }
    /**
     * Metodo encargado de decodificar el token y almacenar la información del usuario en el localStorage.
     *
     * @param data Respuesta de la petición a AUTHENTICATION CIAM.
     * @param jwt JWT recibido en la respuesta de la petición.
     * @param userData Llave utilizada para almacenar la información del usuario en el localStorage.
     */
    decodeToken(data, jwt, userData) {
        let info;
        let dataToken;
        if (data && jwt) {
            try {
                dataToken = jwtDecode(jwt);
                if (dataToken === null || dataToken === void 0 ? void 0 : dataToken.customer) {
                    info = Object.assign(Object.assign({}, data), { customer: Object.assign({}, dataToken.customer) });
                }
                else if (dataToken === null || dataToken === void 0 ? void 0 : dataToken.business) {
                    info = Object.assign(Object.assign({}, data), { business: Object.assign({}, dataToken.business) });
                }
                localStorage.removeItem(userData);
                localStorage.setItem(userData, jwt);
                localStorage.setItem("decode-jwt-".concat(userData), JSON.stringify(info));
                this.emitEventLogin.emit(true);
            }
            catch (error) {
                this.emitEventLogin.emit(false);
                throw new Error('Error al decodificar el token: ' + error);
            }
        }
    }
    /**
     * Funcion encargada de monitorear el estado de la sesión
     */
    EventListenerSession() {
        if (this._eventListenerSession === undefined) {
            this._eventListenerSession = setInterval(() => {
                const date = new Date();
                const anio = date.getFullYear();
                const m = date.getMonth() + 1;
                const month = m < 10 ? "0" + m : m;
                const d = date.getDate();
                const day = d < 10 ? "0" + d : d;
                const h = date.getHours();
                const hours = h < 10 ? "0" + h : h;
                const mt = date.getMinutes();
                const minutes = mt < 10 ? "0" + mt : mt;
                const s = date.getSeconds();
                const seconds = s < 10 ? "0" + s : s;
                const now = day + "-" + month + "-" + anio + ", " + hours + ":" + minutes + ":" + seconds;
                console.log("[x] EventListenerSession - " + now);
                gigya.accounts.getAccountInfo({
                    include: 'data',
                    httpStatusCodes: true,
                    callback: (resp) => {
                        const { errorCode } = resp;
                        // Se cierra la sesión cuando el errorCode <> 0
                        if (errorCode !== 0) {
                            clearInterval(this._eventListenerSession);
                            gigya.accounts.logout({ callback: this.OnLogout });
                        }
                    },
                });
            }, 60000);
        }
    }
    OnLogout() {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    }
};
CiamGlobalsFunctions.ɵfac = function CiamGlobalsFunctions_Factory(t) { return new (t || CiamGlobalsFunctions)(); };
CiamGlobalsFunctions.ɵprov = ɵɵdefineInjectable({ factory: function CiamGlobalsFunctions_Factory() { return new CiamGlobalsFunctions(); }, token: CiamGlobalsFunctions, providedIn: "root" });

const { fetch: originalFetch } = window;
window.fetch = (...args) => __awaiter(void 0, void 0, void 0, function* () {
    let [resource, config] = args;
    // request interceptor here
    // . . .
    // response interceptor here
    const response = yield originalFetch(resource, config);
    if (response.status !== undefined && response.status === 401) {
        gigya.accounts.logout();
    }
    return response;
});
let CiamActiveDirectoryV2Component = class CiamActiveDirectoryV2Component {
    constructor(ciam, cdr) {
        this.ciam = ciam;
        this.cdr = cdr;
        this.showLogin = true;
        this.showLogout = true;
        this.showRegister = true;
        this.showEdit = true;
        this.viewLite = false;
        this._eventListenerLogin = undefined;
        this.contentClazz = 'ngx-content-default-class';
        this.btnClazz = 'ngx-btn-default-class';
        this.redirectLogin = new EventEmitter();
        this.screenLiteRegister = 'gigya-subscribe-with-email-screen';
        this.screenRegister = 'gigya-register-screen';
        this.screenProfile = 'gigya-update-profile-screen';
        this.varUserData = 'x-ColsubAccountInfo-x';
        this.marketings = ['B2B', 'B2C'];
        this.includes = 'profile,data,id_token';
    }
    ngOnInit() {
        if (this.cdnUrl && this.urlAuthenticationCIAM) {
            if (!this.onValidateUrl(this.cdnUrl) ||
                !this.onValidateUrl(this.urlAuthenticationCIAM)) {
                throw new Error(`Las url's deben iniciar con http(s)://`);
            }
        }
        if (!this._isLoadGigya()) {
            this.ciam.addLibraryCiam(this.cdnUrl, this.apiKey);
        }
        if (!this.marketings.includes(this.typeMarketing.toUpperCase())) {
            throw new Error(`Tipo de marketing "${this.typeMarketing}" incorrecto, indique si es B2B o B2C`);
        }
        this.ciam.setItemLocalStorage('show_logout', this.showLogout + '');
        this.ciam.setItemLocalStorage('x-Colsubsidio-Marketing-x', this.typeMarketing);
        this.ciam.setItemSessionStorage('X-CountAuth-X', this.countAuth + '');
        this.ciam.setItemSessionStorage('X-UrlAuthenticationCIAM-X', this.urlAuthenticationCIAM + '');
        this.ciam.setItemSessionStorage('X-VarUserData-X', this.varUserData + '');
        this.ciam.setCookie('xcolsubvarnamex', this.varUserData);
        if (this.ciam.getItemLocalStorage(this.varUserData)) {
            this.showButtonLogout();
        }
        else {
            this.showButtonLogin();
        }
        this.ciam.emitEventLogin.subscribe((resp) => this.redirectLogin.emit(resp));
        this.EventListenerLogin();
        window.addEventListener('load', (event) => {
            if (event.type == 'load') {
                gigya.accounts.addEventHandlers({
                    onLogin: () => this.OnLogin(),
                    onLogout: () => this.OnLogout(),
                });
                // Se verifica si tiene el magiclink
                setTimeout(() => gigya.accounts.getAccountInfo({
                    include: this.includes,
                    httpStatusCodes: true,
                    callback: this.OnAccountInfo,
                }), 1000);
            }
        });
    }
    Login() {
        gigya.accounts.showScreenSet({
            screenSet: this.screenPrefix + '-RegistrationLogin',
            deviceType: 'auto',
            callback: () => {
                this.OnLogin();
            },
        });
    }
    OnLogin(res) {
        this.showButtonLogout();
        gigya.accounts.getAccountInfo({
            include: this.includes,
            httpStatusCodes: true,
            callback: (res) => {
                this.OnAccountInfo(res);
            },
        });
    }
    Logout() {
        this.showButtonLogin();
        gigya.accounts.logout({ callback: this.OnLogout });
    }
    OnLogout() {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    }
    RegisterLite() {
        gigya.accounts.showScreenSet({
            screenSet: this.screenPrefix + '-LiteRegistration',
            deviceType: 'auto',
            startScreen: this.screenLiteRegister,
        });
    }
    Register() {
        gigya.accounts.showScreenSet({
            screenSet: this.screenPrefix + '-RegistrationLogin',
            deviceType: 'auto',
            startScreen: this.screenRegister,
        });
    }
    EditProfile() {
        gigya.accounts.showScreenSet({
            screenSet: this.screenPrefix + '-ProfileUpdate',
            deviceType: 'auto',
            startScreen: this.screenProfile,
        });
    }
    OnAccountInfo(resp) {
        var _a, _b;
        const { errorCode, requestParams } = resp;
        this.ciam = (this.ciam === undefined) ? new CiamGlobalsFunctions() : this.ciam;
        if (errorCode === 0) {
            // Usuario autenticado
            this.ciam.EventListenerSession(); // Listener para verificar la sesión
            // Se almacena el token en de la sesión
            const { APIKey } = requestParams;
            const token = this.ciam.searchCookie(`glt_${APIKey}`);
            this.ciam.setItemSessionStorage('x-Colsub-Token-x', token);
            // Variable donde se deberan guardar los datos de la sesión
            const name = this.ciam.searchCookie('xcolsubvarnamex');
            resp.data.dvIdentificacion =
                this.ciam.calcularDV(resp.data.numeroDocumento) + '';
            this.ciam.setItemSessionStorage(name, JSON.stringify(resp));
            const marketing = this.ciam.getItemLocalStorage('x-Colsubsidio-Marketing-x');
            const authCIAM = (_a = this.ciam.getItemSessionStorage('X-UrlAuthenticationCIAM-X')) !== null && _a !== void 0 ? _a : '';
            const userData = (_b = this.ciam.getItemSessionStorage('X-VarUserData-X')) !== null && _b !== void 0 ? _b : '';
            const cantAuth = resp.data.CantidadAutenticacion;
            const countAuth = Number(this.ciam.getItemSessionStorage('X-CountAuth-X'));
            if (marketing && marketing.toUpperCase() === 'B2B' && !this.ciam.getItemSessionStorage('x-Colsubsidio-Organizacion-x')) {
                // Seleccion de organización
                gigya.accounts.showScreenSet({
                    screenSet: 'ColsubB2B-ProfileUpdate',
                    startScreen: 'gigya-select-organization-screen',
                    deviceType: 'auto',
                    onHide: (res) => {
                        if (res.eventName === "hide")
                            gigya.accounts.b2b.getOrganizationContext({
                                httpStatusCodes: true,
                                callback: (resp) => {
                                    const { errorCode, bpid, orgId } = resp;
                                    if (errorCode === 0) {
                                        gigya.accounts.b2b.getOrganizationInfo({
                                            httpStatusCodes: true,
                                            bpid: bpid,
                                            orgId: orgId,
                                            callback: (resp) => {
                                                this.ciam.setItemSessionStorage('x-Colsubsidio-Organizacion-x', JSON.stringify(resp));
                                                this.ciam.getJWT(APIKey, resp, marketing.toUpperCase(), authCIAM, userData);
                                                if (cantAuth < countAuth && !this.ciam.getItemLocalStorage(userData)) {
                                                    gigya.accounts.showScreenSet({
                                                        screenSet: 'ColsubB2B-ProfileUpdate',
                                                        deviceType: 'auto',
                                                        startScreen: 'gigya-progresive-profile-screen'
                                                    });
                                                }
                                            },
                                        });
                                    }
                                },
                            });
                    },
                });
            }
            else if (marketing &&
                marketing.toUpperCase() === 'B2C' &&
                cantAuth < countAuth &&
                !this.ciam.getItemLocalStorage(userData)) {
                // Activación de datos progresivos
                gigya.accounts.showScreenSet({
                    screenSet: 'ColsubB2C-ProfileUpdate',
                    deviceType: 'auto',
                    startScreen: 'gigya-progresive-profile-screen',
                    onHide: (res) => {
                        if (res.eventName === 'hide')
                            this.ciam.getJWT(APIKey, resp, marketing.toUpperCase(), authCIAM, userData);
                    },
                });
            }
            else {
                this.ciam.getJWT(APIKey, resp, marketing.toUpperCase(), authCIAM, userData);
            }
        }
    }
    onValidateUrl(url) {
        return (url.toLowerCase().startsWith('http://') ||
            url.toLowerCase().startsWith('https://'));
    }
    /**
     *
     * @returns private functions
     */
    _isLoadGigya() {
        let isLoad = false;
        for (var i = 0, scs; scs = document.getElementsByTagName('script')[i]; i++) {
            if (scs.src.indexOf(`${this.cdnUrl}/js/gigya.js?apiKey=${this.apiKey}`) > -1) {
                isLoad = true;
                break;
            }
        }
        return isLoad;
    }
    showButtonLogin() {
        this.showLogin = true;
        this.showRegister = true;
        this.showLogout = false;
        this.showEdit = false;
    }
    showButtonLogout() {
        this.showLogin = false;
        this.showRegister = false;
        this.viewLite = false;
        this.showEdit = true;
        this.showLogout = this.ciam.getItemLocalStorage('show_logout') === 'true';
    }
    EventListenerLogin() {
        if (this._eventListenerLogin === undefined) {
            let c = 0;
            this._eventListenerLogin = setInterval(() => {
                c++;
                if (this.ciam.getItemLocalStorage(this.varUserData)) {
                    this.redirectLogin.emit(true);
                    this.showButtonLogout();
                    clearInterval(this._eventListenerLogin);
                }
                if (c >= 30) {
                    this.redirectLogin.emit(false);
                    clearInterval(this._eventListenerLogin);
                }
            }, 500);
        }
    }
};
CiamActiveDirectoryV2Component.ɵfac = function CiamActiveDirectoryV2Component_Factory(t) { return new (t || CiamActiveDirectoryV2Component)(ɵngcc0.ɵɵdirectiveInject(CiamGlobalsFunctions), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CiamActiveDirectoryV2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CiamActiveDirectoryV2Component, selectors: [["colsubsidio-ciam-active-directory"]], inputs: { showLogout: ["show_logout", "showLogout"], viewLite: ["view_lite", "viewLite"], contentClazz: ["content_class", "contentClazz"], btnClazz: ["btn_class", "btnClazz"], screenLiteRegister: ["screen_register_lite", "screenLiteRegister"], screenRegister: ["screen_register", "screenRegister"], screenProfile: ["screen_profile", "screenProfile"], varUserData: ["var_userdata", "varUserData"], apiKey: ["api_key", "apiKey"], cdnUrl: ["cdn_url", "cdnUrl"], screenPrefix: ["screen_prefix", "screenPrefix"], typeMarketing: ["type_marketing", "typeMarketing"], countAuth: ["count_auth", "countAuth"], urlAuthenticationCIAM: ["url_authentication_ciam", "urlAuthenticationCIAM"] }, outputs: { redirectLogin: "result_auth" }, decls: 7, vars: 9, consts: [["id", "ngx-gigya-register-lite", 3, "class", "click", 4, "ngIf"], ["id", "ngx-gigya-register", 3, "class", "click", 4, "ngIf"], ["id", "ngx-gigya-login", 3, "class", "click", 4, "ngIf"], ["id", "ngx-gigya-logout", 3, "class", "click", 4, "ngIf"], ["id", "ngx-gigya-edit-profile", 3, "class", "click", 4, "ngIf"], ["class", "ngx-content-default-separator", 4, "ngIf"], ["id", "ngx-gigya-register-lite", 3, "click"], ["id", "ngx-gigya-register", 3, "click"], ["id", "ngx-gigya-login", 3, "click"], ["id", "ngx-gigya-logout", 3, "click"], ["id", "ngx-gigya-edit-profile", 3, "click"], [1, "ngx-content-default-separator"]], template: function CiamActiveDirectoryV2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, CiamActiveDirectoryV2Component_button_1_Template, 2, 3, "button", 0);
        ɵngcc0.ɵɵtemplate(2, CiamActiveDirectoryV2Component_button_2_Template, 2, 3, "button", 1);
        ɵngcc0.ɵɵtemplate(3, CiamActiveDirectoryV2Component_button_3_Template, 2, 3, "button", 2);
        ɵngcc0.ɵɵtemplate(4, CiamActiveDirectoryV2Component_button_4_Template, 2, 3, "button", 3);
        ɵngcc0.ɵɵtemplate(5, CiamActiveDirectoryV2Component_button_5_Template, 2, 3, "button", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, CiamActiveDirectoryV2Component_div_6_Template, 1, 0, "div", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.contentClazz);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.viewLite === true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRegister);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLogin);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLogout === true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showEdit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contentClazz == "ngx-content-default-class");
    } }, directives: [ɵngcc1.NgIf], styles: ["html[_ngcontent-%COMP%]{margin:0!important;padding:0!important}.ngx-content-default-class[_ngcontent-%COMP%]{position:absolute;display:block;width:100%!important;height:40px;background-color:#0067b1;margin:0;padding:0;top:0;right:0;left:0;z-index:10000}.ngx-content-default-separator[_ngcontent-%COMP%]{display:block;width:100%!important;height:40px}.ngx-btn-default-class[_ngcontent-%COMP%]{background-color:#ffd000;border:none;width:auto;height:35px;color:#0067b1;float:right;margin:2.5px;cursor:pointer;font-weight:500;font-size:14px;border-radius:3px;padding:0 5px}.ngx-btn-default-class[_ngcontent-%COMP%]:active{background-color:#ffd000cc}.ngx-colsub-display-none[_ngcontent-%COMP%]{display:none}"] });
CiamActiveDirectoryV2Component.ctorParameters = () => [
    { type: CiamGlobalsFunctions },
    { type: ChangeDetectorRef }
];
__decorate([
    Input('show_logout')
], CiamActiveDirectoryV2Component.prototype, "showLogout", void 0);
__decorate([
    Input('view_lite')
], CiamActiveDirectoryV2Component.prototype, "viewLite", void 0);
__decorate([
    Input('api_key')
], CiamActiveDirectoryV2Component.prototype, "apiKey", void 0);
__decorate([
    Input('cdn_url')
], CiamActiveDirectoryV2Component.prototype, "cdnUrl", void 0);
__decorate([
    Input('content_class')
], CiamActiveDirectoryV2Component.prototype, "contentClazz", void 0);
__decorate([
    Input('btn_class')
], CiamActiveDirectoryV2Component.prototype, "btnClazz", void 0);
__decorate([
    Input('screen_prefix')
], CiamActiveDirectoryV2Component.prototype, "screenPrefix", void 0);
__decorate([
    Output('result_auth')
], CiamActiveDirectoryV2Component.prototype, "redirectLogin", void 0);
__decorate([
    Input('screen_register_lite')
], CiamActiveDirectoryV2Component.prototype, "screenLiteRegister", void 0);
__decorate([
    Input('screen_register')
], CiamActiveDirectoryV2Component.prototype, "screenRegister", void 0);
__decorate([
    Input('screen_profile')
], CiamActiveDirectoryV2Component.prototype, "screenProfile", void 0);
__decorate([
    Input('var_userdata')
], CiamActiveDirectoryV2Component.prototype, "varUserData", void 0);
__decorate([
    Input('type_marketing')
], CiamActiveDirectoryV2Component.prototype, "typeMarketing", void 0);
__decorate([
    Input('count_auth')
], CiamActiveDirectoryV2Component.prototype, "countAuth", void 0);
__decorate([
    Input('url_authentication_ciam')
], CiamActiveDirectoryV2Component.prototype, "urlAuthenticationCIAM", void 0);

let CiamActiveDirectoryV2Module = class CiamActiveDirectoryV2Module {
};
CiamActiveDirectoryV2Module.ɵfac = function CiamActiveDirectoryV2Module_Factory(t) { return new (t || CiamActiveDirectoryV2Module)(); };
CiamActiveDirectoryV2Module.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CiamActiveDirectoryV2Module });
CiamActiveDirectoryV2Module.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CiamGlobalsFunctions, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CiamActiveDirectoryV2Component, [{
        type: Component,
        args: [{
                selector: 'colsubsidio-ciam-active-directory',
                template: `
    <div class="{{ contentClazz }}">
      <button
        class="{{ btnClazz }} ngx-not-authenticate"
        (click)="RegisterLite()"
        *ngIf="viewLite === true"
        id="ngx-gigya-register-lite"
      >
        Crear cuenta lite
      </button>
      <button
        class="{{ btnClazz }} ngx-not-authenticate"
        (click)="Register()"
        *ngIf="showRegister"
        id="ngx-gigya-register"
      >
        Crear cuenta
      </button>
      <button
        *ngIf="showLogin"
        class="{{ btnClazz }} ngx-not-authenticate"
        (click)="Login()"
        id="ngx-gigya-login"
      >
        Iniciar Sesión
      </button>
      <button
        *ngIf="showLogout === true"
        class="{{ btnClazz }} ngx-authenticate"
        (click)="Logout()"
        id="ngx-gigya-logout"
      >
        Cerrar Sesión
      </button>
      <button
        class="{{ btnClazz }} ngx-authenticate"
        *ngIf="showEdit"
        (click)="EditProfile()"
        id="ngx-gigya-edit-profile"
      >
        Editar Cuenta
      </button>
    </div>
    <div
      *ngIf="contentClazz == 'ngx-content-default-class'"
      class="ngx-content-default-separator"
    ></div>
  `,
                styles: ["html{margin:0!important;padding:0!important}.ngx-content-default-class{position:absolute;display:block;width:100%!important;height:40px;background-color:#0067b1;margin:0;padding:0;top:0;right:0;left:0;z-index:10000}.ngx-content-default-separator{display:block;width:100%!important;height:40px}.ngx-btn-default-class{background-color:#ffd000;border:none;width:auto;height:35px;color:#0067b1;float:right;margin:2.5px;cursor:pointer;font-weight:500;font-size:14px;border-radius:3px;padding:0 5px}.ngx-btn-default-class:active{background-color:#ffd000cc}.ngx-colsub-display-none{display:none}"]
            }]
    }], function () { return [{ type: CiamGlobalsFunctions }, { type: ɵngcc0.ChangeDetectorRef }]; }, { showLogout: [{
            type: Input,
            args: ['show_logout']
        }], viewLite: [{
            type: Input,
            args: ['view_lite']
        }], contentClazz: [{
            type: Input,
            args: ['content_class']
        }], btnClazz: [{
            type: Input,
            args: ['btn_class']
        }], redirectLogin: [{
            type: Output,
            args: ['result_auth']
        }], screenLiteRegister: [{
            type: Input,
            args: ['screen_register_lite']
        }], screenRegister: [{
            type: Input,
            args: ['screen_register']
        }], screenProfile: [{
            type: Input,
            args: ['screen_profile']
        }], varUserData: [{
            type: Input,
            args: ['var_userdata']
        }], apiKey: [{
            type: Input,
            args: ['api_key']
        }], cdnUrl: [{
            type: Input,
            args: ['cdn_url']
        }], screenPrefix: [{
            type: Input,
            args: ['screen_prefix']
        }], typeMarketing: [{
            type: Input,
            args: ['type_marketing']
        }], countAuth: [{
            type: Input,
            args: ['count_auth']
        }], urlAuthenticationCIAM: [{
            type: Input,
            args: ['url_authentication_ciam']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CiamActiveDirectoryV2Module, { declarations: function () { return [CiamActiveDirectoryV2Component]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CiamActiveDirectoryV2Component]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CiamActiveDirectoryV2Module, [{
        type: NgModule,
        args: [{
                declarations: [CiamActiveDirectoryV2Component],
                imports: [
                    CommonModule
                ],
                exports: [CiamActiveDirectoryV2Component]
            }]
    }], null, null); })();

/*
 * Public API Surface of ciam-active-directory-v2
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CiamActiveDirectoryV2Component, CiamActiveDirectoryV2Module, CiamGlobalsFunctions };

//# sourceMappingURL=ciam-active-directory-ang9x.js.map